import {Component, computed, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {STEP_PHASE_MAP} from '../../models/step-phase-map';
import {IackathonSave, IackathonSaveListItem, isIackathonInvalidSave} from '../../services/iackathon-saves.service';

@Component({
    selector: 'app-iackathon-group',
    imports: [
        RouterLink,
        TranslateModule
    ],
    templateUrl: './iackathon-group.component.html',
    host: {'role': 'article'},
})
export class IackathonGroupComponent {
    save = input.required<IackathonSaveListItem>();
    protected readonly invalid = computed(() => isIackathonInvalidSave(this.save()));
    protected readonly errorKey = computed(() => {
        const save = this.save();

        return isIackathonInvalidSave(save) ? save.errorKey : '';
    });
    protected readonly ownerUsername = computed(() => {
        const save = this.save();

        return isIackathonInvalidSave(save) ? save.ownerUsername : save.attributes.owner?.username;
    });
    private readonly validSave = computed<IackathonSave | null>(() => {
        const save = this.save();

        return isIackathonInvalidSave(save) ? null : save;
    });
    protected readonly outdated = computed(() => !this.validSave()?.attributes.content.state.group_name);
    protected readonly groupName = computed(() => this.validSave()?.attributes.content.state.group_name)
    protected readonly saveAuthor = computed(() => this.validSave()?.attributes.content.state.author_name)
    protected readonly members = computed(() => {
        const members = this.validSave()?.attributes.content.state.members;

        return Array.isArray(members) ? members : [];
    })
    protected readonly indexCurrentPhase = computed(() => this.getCurrentPhaseIndex(this.validSave()?.attributes.content.state.current_step_id))
    private readonly deliverable = computed(() => this.validSave()?.attributes.content.state.deliverable)
    protected readonly hasDeliverable = computed(() => !!this.deliverable()?.url)

    private getCurrentPhaseIndex(current_step_id?: string): number {
        if (!current_step_id || current_step_id in STEP_PHASE_MAP === false) {
            return 0;
        }

        const phase = STEP_PHASE_MAP[current_step_id];
        const indexStr = phase.replace('phase_', '');

        switch (indexStr) {
            case '01': return 1;
            case '02': return 2;
            case '03': return 3;
            case '04': return 4;
            default: return 0;
        }

    }
}
